import React from 'react'
import { Spinner, Flex } from '@chakra-ui/core'

const CenteredLoading = () => {
	return (
		<Flex flex={1} alignItems='center'>
			<Spinner size='lg' color='brand.activeBlue' mx='auto' />
		</Flex>
	)
}

export default CenteredLoading